import { AlertCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export function ReportNoAccessCard() {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-16 gap-3">
        <AlertCircle className="h-10 w-10 text-muted-foreground opacity-40" />
        <p className="text-sm text-muted-foreground">You don't have access to this report.</p>
      </CardContent>
    </Card>
  );
}
